import { render } from "./Introduce.vue?vue&type=template&id=598d43c7&scoped=true"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"

import "@/assets/css/layout_introduce.css?vue&type=style&index=0&id=598d43c7&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598d43c7"]])

export default __exports__